<div class="modal-header">
  <div class="modal-title">
    <h3 class="mb-0">Change contact roles</h3>
    <p class="modal-subtitle mb-0">
      Mark which contact channels this person is on, and which channel they
      primarily own.
    </p>
  </div>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="close()"
  ></button>
</div>

<form class="modal-body" [formGroup]="ContactFormGroup">
  <div class="ect-roles">
    <!-- Bid -->
    <div class="ect-role">
      <div class="form-check ect-role__toggle">
        <input
          id="ect-isBid"
          class="form-check-input"
          type="checkbox"
          formControlName="isBid"
        />
        <label for="ect-isBid" class="form-check-label"> Bid contact </label>
      </div>
      @if (ContactFormGroup.controls['isBid'].value) {
        <div class="form-check ect-role__primary">
          <input
            id="ect-isPrimaryBid"
            class="form-check-input"
            type="checkbox"
            formControlName="isPrimaryBid"
          />
          <label for="ect-isPrimaryBid" class="form-check-label">
            Primary bid contact
          </label>
        </div>
      }
    </div>

    <!-- Billing -->
    <div class="ect-role">
      <div class="form-check ect-role__toggle">
        <input
          id="ect-isBilling"
          class="form-check-input"
          type="checkbox"
          formControlName="isBilling"
        />
        <label for="ect-isBilling" class="form-check-label">
          Billing contact
        </label>
      </div>
      @if (ContactFormGroup.controls['isBilling'].value) {
        <div class="form-check ect-role__primary">
          <input
            id="ect-isPrimaryBilling"
            class="form-check-input"
            type="checkbox"
            formControlName="isPrimaryBilling"
          />
          <label for="ect-isPrimaryBilling" class="form-check-label">
            Primary billing contact
          </label>
        </div>
      }
    </div>

    <!-- Compliance -->
    <div class="ect-role">
      <div class="form-check ect-role__toggle">
        <input
          id="ect-isCompliance"
          class="form-check-input"
          type="checkbox"
          formControlName="isCompliance"
        />
        <label for="ect-isCompliance" class="form-check-label">
          Compliance contact
        </label>
      </div>
      @if (ContactFormGroup.controls['isCompliance'].value) {
        <div class="form-check ect-role__primary">
          <input
            id="ect-isPrimaryCompliance"
            class="form-check-input"
            type="checkbox"
            formControlName="isPrimaryCompliance"
          />
          <label for="ect-isPrimaryCompliance" class="form-check-label">
            Primary compliance contact
          </label>
        </div>
      }
    </div>
  </div>
</form>

<div class="modal-footer">
  <div class="action-row justify-end w-100">
    <button type="button" class="btn btn-ghost" (click)="close()">
      Cancel
    </button>
    <button type="button" class="btn btn-primary" (click)="save()">
      Save roles
    </button>
  </div>
</div>
